export default {
  computed: {
    editProductData: {
      get() {
        return this.getVuexProperty('editProductData');
      },
      set(editProductData) {
        if (editProductData.colours) {
          if (typeof editProductData.colours === 'string') {
            editProductData.colours = editProductData.colours.split(', ');
          }
        }
        this.setVuexProperty('editProductData', editProductData);
      },
    },
    editMode: {
      get() {
        return this.getVuexProperty('editMode');
      },
      set(value) {
        this.setVuexProperty('editMode', value);
      },
    },
  },
};
